export enum SettingValueType {
  ATTACHMENT = 'ATTACHMENT',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  FUNCTION = 'FUNCTION',
  JSON = 'JSON',
  HTML = 'HTML',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
  STRUCTURE_NODE_MAPPING = 'STRUCTURE_NODE_MAPPING',
  FILE = 'FILE',
  VALORIZATION_INDEX = 'VALORIZATION_INDEX'
}
